import { ApiService }              from '../../app-lite/api/api.service';
import { CompanyMessagesModel }    from '../../app-lite/companies/models/company.messages';
import { SessionService }          from '../../app-lite/sessions/session.service';
import { TemplatedWordingService } from '../../app-lite/templates/templated-wording.service';
import { TemplateModel }           from '../../app-lite/templates/typings/template';

interface RemindersScope extends ng.IScope {
  addEmailTemplates: ( type : string ) => void;
  addSMSTemplates  : ( type : string ) => void;
  company          : any;
  form             : ng.IFormController;
  regoLabel        : string;
  save             : () => void;
  messages         : CompanyMessagesModel;
};

export function RemindersCtrl (
  $scope          : RemindersScope,
  $state          : ng.ui.IStateService,
  $translate      : ng.translate.ITranslateService,
  company         : any,
  companyMessages : CompanyMessagesModel,
  messages        : any,
  sessionObjAPI   : SessionService,
  templatedWording: TemplatedWordingService,
  workshopAPI     : ApiService
) {
  $scope.company   = company;
  $scope.messages  = companyMessages;
  $scope.regoLabel = company.company_variable_fields.plate_number_name || sessionObjAPI.countrySettings().rego_label;

  $scope.save = function () {
    workshopAPI.patch('/company_message_settings', $scope.messages)
    .then(() => workshopAPI.patch('/company', $scope.company, 'company'))
    .then(() => {
      $scope.form.$setPristine();

      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.REMINDERS'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.addEmailTemplates = function ( type = '' ) {
    templatedWording.addTemplate('email')
    .then(( templates : Array<TemplateModel> ) => {
      angular.forEach(templates, template => {
        if ( type === 'followUp' ) {
          $scope.messages.quote_followup_message = $scope.messages.quote_followup_message
            ? `${ $scope.messages.quote_followup_message }\n\n${ template.wording }`
            : template.wording;
        } else {
          $scope.messages.default_service_reminder = $scope.messages.default_service_reminder
            ? `${ $scope.messages.default_service_reminder }\n\n${ template.wording }`
            : template.wording;
        }
      });
    });
  };

  $scope.addSMSTemplates = function ( type = '' ) {
    templatedWording.addTemplate('sms')
    .then(( templates : Array<TemplateModel> ) => {
      angular.forEach(templates, template => {
        if ( type === 'followUp' ) {
          $scope.messages.quote_followup_message_sms = $scope.messages.quote_followup_message_sms
            ? `${ $scope.messages.quote_followup_message_sms }\n\n${ template.wording }`
            : template.wording;
        } else {
          $scope.messages.default_service_reminder_sms = $scope.messages.default_service_reminder_sms
            ? `${ $scope.messages.default_service_reminder_sms }\n\n${ template.wording }`
            : template.wording;
        }
      });
    });
  };
}
